import React, { Component } from 'react';
import GreenButton from '../misc/GreenButton'
import Axios from 'axios';

export class AgeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            link: null,
            ageGroups: []
        };
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentWillMount() {
        Axios.get(`http://web.wholechildapp.com/api/content`).then(res =>
            this.setState({
                ageGroups: res.data.data.ageGroups
            }))

    }

    handleFormSubmit = formSubmitEvent => {
        formSubmitEvent.preventDefault();
        this.props.handleChangeForced('link', this.state.link);
        this.props.handleChangeForced('ageGroupID', this.state.link);
    };

    continue = e => {
        e.preventDefault();
        this.props.nextStep();
    };

    chooseCategory = link => () => {
        this.setState({ link });
    };

    render() {
        const { ageGroups, link } = this.state;

        let turnedOn = {
            visibility: 'hidden'
        }
        if (link) {
            turnedOn = {
                visibility: 'visible'
            }
        }
        return (
            <form onSubmit={this.handleFormSubmit}>
                {/* <div className="children">
                    <img src={require('../../assets/imgs/kids/1.png')} />
                    <img src={require('../../assets/imgs/kids/2.png')} />
                    <img src={require('../../assets/imgs/kids/3.png')} />
                    <img src={require('../../assets/imgs/kids/4.png')} />
                    <img src={require('../../assets/imgs/kids/5.png')} />
                </div> */}
                <div className="ageList">
                    {ageGroups.map((category, index) => (
                        <div className="ok">
                            <img src={require(`../../assets/imgs/kids/${index + 1}.png`)} />
                            <button key={index} className={`ageListBtn__chooseage ${link === category.id ? 'ageListBtn__active_chooseage' : ''}`}
                                onClick={this.chooseCategory(category.id)}>
                                {category.name}
                            </button>
                        </div>

                    ))}
                </div>
                <div className="welcome-end">
                    <GreenButton
                        style={turnedOn}
                        continue={this.props.nextStep}
                        name="BEGIN TEST"
                    />
                    {/* <img className="mobile-snake" alt="white-snake" src={WhiteSnake} /> */}
                </div>
            </form>
        )
    }
}

export default AgeList
